export default "__VITE_ASSET__CMfN9M_2__"